import { FlagArgs } from '@atlaskit/flag';
import { SharedState } from '@trello/shared-state';

export const flagsState = new SharedState<FlagArgs[]>([]);
